const ApiTags = {
  EVENT_LIST: 'Events',
  EVENT_ATTENDEES: 'EventAttendees',
  BRANCHES: 'Branches',
  LEAD_MANAGEMENT: 'LeadManagement',
  LEAD_EVENTS: 'LeadEvents',
  LEAD_TASKS: 'LeadTasks',
  LEAD_CALLS: 'LeadCalls',
  LEAD_STATUS: 'LeadStatus',
  LEAD_SOURCE: 'LeadSource',
  META_PROVIDER: 'MetaProvider',
  DYNAMIC_COMPONENTS: 'DynamicComponents',
  LEAD_ORG_CONFIG: 'LeadOrgConfig',
  SUBSCRIPTION_LEDGER: 'SubscriptionLedger',
  BRANCH_CONFIG: 'BranchConfig',
  BRANCH_TAGS: 'BranchTags',
  BRANCH_FEE_CATEGORIES: 'BranchFeeCategories',
  FORM_LIST: 'FormList',
  FORM_DETAIL: 'FormDetail',
  FORM_TEMPLATES: 'FormTemplates',
  CUSTOM_ROLES: 'CustomRoles',
  ORGANIZATION_MEMBERS: 'OrganizationMembers',
  INVITED_MEMBERS: 'InvitedMembers',
  PAYMENT_DROPOFF_LIST: 'PaymentDropoffList',
  PAYMENT_DROPOFF_DETAILS: 'PaymentDropoffDetails',
  REMINDER_ELIGIBILITY: 'ReminderEligibility',
  BRANCH_VISIBILITY: 'BranchVisibility'
};

export default ApiTags;
